export const SET_USERS                 = 'SET_USERS';
export const ADD_USER                  = 'ADD_USER';
export const REMOVE_USER               = 'REMOVE_USER';
export const UPDATE_USER               = 'UPDATE_USER';
export const UPDATE_USER_PICTURE       = 'UPDATE_USER_PICTURE';
export const DELETE_USER_PICTURE       = 'DELETE_USER_PICTURE';
export const SET_EXPORT                = 'SET_EXPORT';
export const SET_TEMPLATE              = 'SET_TEMPLATE';
